export default class ApplicationList {
  constructor(applications) {
    this.applications = applications;
  }

  get hasApplications() {
    return this.applications.length > 0;
  }

  get hasInProgressApplications() {
    return this.applications.some((app) => app.isInProgress);
  }

  get inProgressApplications() {
    return this.sortedApplications.filter((app) => app.isInProgress);
  }

  get hasDoneApplications() {
    return this.applications.filter((app) => app.isDone);
  }

  get doneApplications() {
    return this.sortedApplications.filter((app) => app.isDone);
  }

  get hasSubmittedApplications() {
    return this.applications.some((app) => app.isSubmitted);
  }

  get submittedApplications() {
    return this.sortedApplications.filter((app) => app.isSubmitted);
  }

  get sortedApplications() {
    return this.applications.sort((a, b) => {
      if (a.id < b.id) return 1;
      if (a.id > b.id) return -1;
      return 0;
    });
  }
}
